import Plot from 'react-plotly.js';
import * as Plotly from 'plotly.js';
import { chartTypeMap } from '../../utils/constants';
import { abbreviateNumber } from '../../utils/utils';

export default function BarChart({
  barWidthValue,
  barData,
  axisKeys,
  height,
  type,
  minMaxMap
}: {
  barWidthValue: number;
  // barData: BarChartDetails;
  barData: any;
  axisKeys: { key: string; alias: string; color: string }[];
  height: number;
  // eslint-disable-next-line react/require-default-props
  type?: string;
  // eslint-disable-next-line react/require-default-props
  minMaxMap?: object;
}) {
  const yAxis: string[] = [];
  // const xAxis: {label : string; value: number}[] = [];
  const xAxis: number[] | any = [];
  const txt: any[] = [];
  axisKeys
    .slice()
    .reverse()
    .forEach((axisData) => {
      xAxis.push(barData[axisData.key]);
      yAxis.push(axisData.key);
      txt.push({
        label: `${axisData.alias}`,
        value: abbreviateNumber('', barData[axisData.key], 1)
      });
    });

  const plotData: Plotly.Data = {
    type: 'bar',
    x: xAxis,
    y: yAxis,
    hovertext: txt,
    orientation: 'h',
    width: 0.4,
    name: '',
    hovertemplate:
      '<b>%{hovertext.label}</b><br>' +
      '%{hovertext.value}<br>' +
      '<extra></extra>',
    marker: {
      color: axisKeys
        .slice()
        .reverse()
        .map((axisData) => axisData.color)
    }
  };

  let layout: Partial<Plotly.Layout> = {
    width: barWidthValue,
    height,
    xaxis: {
      showgrid: false,
      zerolinecolor: '#C4C4C4',
      zerolinewidth: 1,
      linecolor: '#C4C4C4',
      showline: false,
      fixedrange: true
    },
    yaxis: {
      showgrid: false,
      showline: false,
      fixedrange: true
    },
    margin: {
      r: 0,
      t: 0,
      l: 0,
      b: 0
    },
    bargap: 0,
    title: '',
    autosize: true,
    showlegend: false,
    hoverlabel: {
      bgcolor: '#f3f3f3',
      align: 'left',
      font: {
        size: 10
      }
    },
    barmode: 'stack'
  };

  // setting the range for the comparison bar chart
  if (type === chartTypeMap.comparisonBarChart) {
    // eslint-disable-next-line prefer-const
    let clonedLayout = JSON.parse(JSON.stringify(layout));
    // getting min & max
    const minValue = minMaxMap[barData.metric].min;
    const maxValue = minMaxMap[barData.metric].max;

    let rangeArray = [];
    let constraintValue;
    if (minValue > 0 && maxValue > 0) {
      rangeArray = [0, maxValue];
      constraintValue = 'left';
    } else if (minValue < 0 && maxValue < 0) {
      rangeArray = [minValue, 0];
      constraintValue = 'right';
    } else {
      rangeArray = [minValue, maxValue];
      constraintValue = 'center';
    }

    // getting the first & only value from xAxis data
    const barValue = xAxis[0];
    // setting the range as per the value
    // clonedLayout.xaxis.range = barValue > 0 ? [0, barValue] : [barValue, 0];
    clonedLayout.xaxis.range = rangeArray;
    clonedLayout.xaxis.constraintoward = constraintValue;
    layout = clonedLayout;
  }

  // center aligning axis for difference bar chart
  if (type === chartTypeMap.metricsDifferenceChart) {
    // eslint-disable-next-line prefer-const
    let clonedLayout = JSON.parse(JSON.stringify(layout));
    clonedLayout.xaxis.constraintoward = 'center';
    const maxValue = Math.max(...xAxis.map((num) => Math.abs(num)));
    clonedLayout.xaxis.range = [-1 * maxValue, maxValue];
    layout = clonedLayout;
  }

  return (
    <div className='bar-chart-container'
    style={{ paddingTop: '8px' }}>
      <Plot
        data={[plotData]}
        layout={layout}
        config={{ displayModeBar: false }}
      />
    </div>
  );
}
